import React from "react";
import styled from "styled-components";

const DialogFooterStyle = styled.div`
    padding: 10px 30px;
    border-top: 1px solid ${props => props.theme.greyLight};
    >div {
        display: flex;
        justify-content: flex-end;
    }
`;

export const DialogFooter = ({ children }) =>
    <DialogFooterStyle>
        <div>
            {children}
        </div>
    </DialogFooterStyle>;